module.exports = __webpack_public_path__ + "static/img/medical.8c84b1d3.png";